import { useState } from "react";
import { FadeUp } from "./FadeUp";

const PLANS = {
  veg: [
    { meal: "Breakfast", dish: "Poha with peanuts", cal: 320, protein: 8, img: "https://images.unsplash.com/photo-1789991184412-c29c9dfa2b39?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Lunch", dish: "Dal + Roti + Sabzi", cal: 480, protein: 18, img: "https://images.unsplash.com/photo-1559561724-732dbca7be1e?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Snack", dish: "Greek yogurt with fruits", cal: 220, protein: 14, img: "https://images.unsplash.com/photo-1530259152377-3a014e1092e0?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Dinner", dish: "Paneer bhurji with roti", cal: 440, protein: 24, img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85" },
  ],
  nonveg: [
    { meal: "Breakfast", dish: "Egg omelette with toast", cal: 340, protein: 20, img: "https://images.unsplash.com/photo-1788462612950-b4a7163d1d25?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Lunch", dish: "Chicken curry with rice", cal: 560, protein: 38, img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Snack", dish: "Boiled eggs (2)", cal: 150, protein: 12, img: "https://images.unsplash.com/photo-1606636661147-51df1c246ccf?crop=entropy&cs=srgb&fm=jpg&q=85" },
    { meal: "Dinner", dish: "Grilled fish with salad", cal: 420, protein: 36, img: "https://images.unsplash.com/photo-1665401015549-712c0dc5ef85?crop=entropy&cs=srgb&fm=jpg&q=85" },
  ],
};

export const SampleDayPlan = () => {
  const [type, setType] = useState("veg");
  const meals = PLANS[type];
  const totalCal = meals.reduce((a, m) => a + m.cal, 0);
  const totalProtein = meals.reduce((a, m) => a + m.protein, 0);

  return (
    <section id="sample-day" className="py-14 md:py-20 px-6 bg-[#111113]">
      <div className="max-w-5xl mx-auto">
        <FadeUp>
          <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-8 md:mb-10">
            A DAY ON FORGE
          </h2>
        </FadeUp>

        <div className="flex justify-center gap-3 mb-10">
          {[
            { id: "veg", label: "Veg" },
            { id: "nonveg", label: "Non-Veg" },
          ].map((t) => (
            <button
              key={t.id}
              data-testid={`day-plan-toggle-${t.id === "nonveg" ? "nonveg" : "veg"}`}
              onClick={() => setType(t.id)}
              className={`tap-target px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 ${
                type === t.id
                  ? "bg-[#C6FF3D] text-black"
                  : "bg-[#141416] text-[#A1A1AA] border border-[#232326] hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-5 mb-10">
          {meals.map((m) => (
            <FadeUp key={m.meal}>
              <div
                data-testid={`meal-card-${m.meal.toLowerCase()}`}
                className="bg-[#141416] border border-[#232326] rounded-[20px] overflow-hidden h-full hover:-translate-y-1 hover:border-[#C6FF3D]/40 transition-all duration-300"
              >
                <img
                  src={m.img}
                  alt={`${m.dish}, ${m.meal.toLowerCase()} on the FORGE ${type === "veg" ? "vegetarian" : "non-vegetarian"} plan`}
                  className="w-full h-28 object-cover"
                />
                <div className="p-5">
                  <span className="text-[#C6FF3D] text-xs font-semibold tracking-widest uppercase">{m.meal}</span>
                  <h3 className="text-white font-semibold mt-2 mb-4 text-sm">{m.dish}</h3>
                  <div className="flex justify-between text-xs text-[#A1A1AA]">
                    <span>{m.cal} kcal</span>
                    <span>{m.protein}g protein</span>
                  </div>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp>
          <div
            data-testid="day-plan-totals"
            className="bg-[#141416] border border-[#C6FF3D]/30 rounded-[24px] p-8 flex flex-col sm:flex-row justify-around text-center gap-6"
          >
            <div>
              <p className="font-display text-3xl text-[#C6FF3D]">{totalCal}</p>
              <p className="text-[#A1A1AA] text-xs mt-1">Total Calories</p>
            </div>
            <div>
              <p className="font-display text-3xl text-[#C6FF3D]">{totalProtein}g</p>
              <p className="text-[#A1A1AA] text-xs mt-1">Total Protein</p>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
